import { SensorSlot } from "../../../../types/types";
import DeviceNetworkSensorData from "./DeviceNetworkSensorData";
import DeviceSensorData from "./DeviceSensorData";


const DeviceSlot = ({slot, selectedDate}:{slot: SensorSlot, selectedDate: {from: Date, to: Date}}) => {
    return (
        <div className="flex flex-col space-y-4 pb-20">
            {slot.sensors.filter(s => !["ac_min", "ac_max", "ac_avg"].includes(s.sensor_type.data_key_name)).map(sensor => 
                sensor ? <DeviceSensorData key={sensor.id} sensor={sensor} sensorId={String(sensor.id!)} selectedDate={selectedDate}/> : <></>
            )}
        </div>
    )
}

export default DeviceSlot;